import { useCoaLibrary } from "@/lib/products";

const STATIC = ["COA Verified", "Research Use Only", "HPLC & Mass Spec", "Cold-Chain Dispatch", "Manufactured by Axis Bio Lab"];

export default function Marquee() {
  const rows = useCoaLibrary();
  const lots = [];
  const seen = new Set();
  for (const r of rows) {
    if (r.lot && !seen.has(r.lot)) { seen.add(r.lot); lots.push(`${r.name} · Lot ${r.lot}`); }
  }
  const items = [];
  lots.slice(0, 14).forEach((l, i) => { items.push(l); items.push(STATIC[i % STATIC.length]); });
  if (!items.length) STATIC.forEach((s) => items.push(s));
  const track = [...items, ...items];

  return (
    <div className="marquee border-y border-slate-200 bg-white overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex items-center gap-12 py-3 w-max">
        {track.map((t, i) => (
          <span key={i} className={`font-tech text-[11px] uppercase tracking-[0.2em] whitespace-nowrap flex items-center gap-12 ${
            STATIC.includes(t) ? "text-sky-700" : "text-slate-500"}`}>
            {t}<span className="h-1 w-1 rounded-full bg-slate-300 inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
